import { DynamicForm, FormConfig, OptionType } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect, useState } from "react";
import { FieldValues, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../../constants";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import axios from "axios";
import { decodeHTML } from "~/Utils/CommonUtils";
import { FetchSubModule } from "../../Shop/ShopList/ShopListOptions";
import { useLandingPageContenDocumentDetails } from "./DineList.hooks";

export const AddEditDineListPageContent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [currentAirport] = useLocalStorage("currentAirport", null);
  const [airportDropdownOptions, setAirportDropdownOptions] = useState<{ label: string; value: string }[]>([]);
  const [zonePublicDropdownOptions, setZonePublicDropdownOptions] = useState<{ label: string; value: string }[]>([]);
  const [zonePassengerDropdownOptions, setZonePassengerDropdownOptions] = useState<{ label: string; value: string }[]>([]);
  const [zoneLevelsDropdownOptions, setZoneLevelsDropdownOptions] = useState<{ label: string; value: string }[]>([]);
  const [kliaAirportDropdownOptions, setKliaAirportDropdownOptions] = useState<{ label: string; value: string }[]>([]);
  const fetchAirportDropdownOptions = async () => {
    try {
      const response = await axios.get(`${passengerHost}/api/shop-category-parent?airport=${currentAirport}`);
      const data = response?.data || [];
      const options = data.map((item: { id: string; name: string }) => ({
        value: item.id,
        label: decodeHTML(item.name),
      }));
      setAirportDropdownOptions(options);
    } catch (error) {
      console.error("Failed to fetch store dropdown:", error);
    }
  };
  const fetchKliaAirportDropdownOptions = async () => {
    try {
      const response = await axios.get(`${passengerHost}/api/shop-category-child?airport=${currentAirport}`);
      const data = response?.data || [];
      const filtered = data.filter(
        (item: any) => item.type?.toLowerCase() === "dine"
      );
      const options = filtered.map(
        (item: { id: string; name: string }) => ({
          value: item.id,
          label: decodeHTML(item.name),
        })
      );
      setKliaAirportDropdownOptions(options);
    } catch (error) {
      console.error("Failed to fetch store dropdown:", error);
    }
  };
  const fetchZonePageDropdownOptions = async () => {
    try {
      const response = await axios.get(`${passengerHost}/api/zonelevel-public`);
      const data = response?.data || [];
      const filteredZonePublic = data.filter(
        (item: any) => item.parent_term_name?.toLowerCase() === "public"
      );
      const zonePublicOptions = filteredZonePublic.map(
        (item: { id: string; name: string }) => ({
          value: item.id,
          label: decodeHTML(item.name),
        })
      );
      const filteredZonePassenger = data.filter(
        (item: any) => item.parent_term_name?.toLowerCase() === "passenger"
      );
      const zonePassengerOptions = filteredZonePassenger.map(
        (item: { id: string; name: string }) => ({
          value: item.id,
          label: decodeHTML(item.name),
        })
      );
      setZonePublicDropdownOptions(zonePublicOptions);
      setZonePassengerDropdownOptions(zonePassengerOptions);
    } catch (error) {
      console.error("Failed to fetch store dropdown:", error);
    }
  };
  const fetchZoneLevelsDropdownOptions = async () => {
    try {
      const response = await axios.get(`${passengerHost}/api/zonelevel-parent`);
      const envelopes = response?.data || [];
      const filtered = envelopes.filter(
        (item: any) => !(
          (item.name === "Public" || item.name === "Passenger") &&
          item.parent_term_id === ""
        )
      );
      const zoneLevelsOptions = filtered.map(
        (item: { id: string; name: string }) => ({
          value: item.id,
          label: decodeHTML(item.name),
        })
      );
      setZoneLevelsDropdownOptions(zoneLevelsOptions);
    } catch (error) {
      console.error("Failed to fetch store dropdown:", error);
    }
  };
  useEffect(()=>{
    fetchAirportDropdownOptions();
    fetchKliaAirportDropdownOptions();
    fetchZonePageDropdownOptions();
    fetchZoneLevelsDropdownOptions();
  },[])
  const {
    data: editHelpHeading,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useLandingPageContenDocumentDetails(query.get("editId") || "");

  const {
    data: editHelpHeadingById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "pageHeading") {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  const formConfig: FormConfig = {
    initialValues: {
    zone:
      decodeHTML(editHelpHeadingById?.payload?.zone) ||
      decodeHTML(editHelpHeading?.zone) ||
      "",
    zoneLevel:
      decodeHTML(editHelpHeadingById?.payload?.zoneLevel) ||
      decodeHTML(editHelpHeading?.zoneLevel) ||
      "",
    category:
      decodeHTML(editHelpHeadingById?.payload?.category) ||
      decodeHTML(editHelpHeading?.category) ||
      "",
    field_product_name_en:
      decodeHTML(editHelpHeadingById?.payload?.field_product_name_en) ||
      decodeHTML(editHelpHeading?.field_product_name_en) ||
      "",
    field_product_name_ms:
      decodeHTML(editHelpHeadingById?.payload?.field_product_name_ms) ||
      decodeHTML(editHelpHeading?.field_product_name_ms) ||
      "",
    field_product_name_zh:
      decodeHTML(editHelpHeadingById?.payload?.field_product_name_zh) ||
      decodeHTML(editHelpHeading?.field_product_name_zh) ||
      "",
    field_shop_store_hour_value_en:
      decodeHTML(editHelpHeadingById?.payload?.field_shop_store_hour_value_en) ||
      decodeHTML(editHelpHeading?.field_shop_store_hour_value_en) ||
      "",
    field_shop_store_hour_value_ms:
      decodeHTML(editHelpHeadingById?.payload?.field_shop_store_hour_value_ms) ||
      decodeHTML(editHelpHeading?.field_shop_store_hour_value_ms) ||
      "",
    field_shop_store_hour_value_zh:
      decodeHTML(editHelpHeadingById?.payload?.field_shop_store_hour_value_zh) ||
      decodeHTML(editHelpHeading?.field_shop_store_hour_value_zh) ||
      "",
    field_shop_location_value_en:
      decodeHTML(editHelpHeadingById?.payload?.field_shop_location_value_en) ||
      decodeHTML(editHelpHeading?.field_shop_location_value_en) ||
      "",
    field_shop_location_value_ms:
      decodeHTML(editHelpHeadingById?.payload?.field_shop_location_value_ms) ||
      decodeHTML(editHelpHeading?.field_shop_location_value_ms) ||
      "",
    field_shop_location_value_zh:
      decodeHTML(editHelpHeadingById?.payload?.field_shop_location_value_zh) ||
      decodeHTML(editHelpHeading?.field_shop_location_value_zh) ||
      "",
    published:
      editHelpHeadingById?.payload?.published ??
      editHelpHeading?.published ??
      false,
    image: editHelpHeadingById?.payload
      ? [
          {
            uid: "-1",
            name: "useful-tips.jpg",
            status: "done",
            url: decodeHTML(editHelpHeadingById?.payload?.image),
          },
        ]
      : editHelpHeading
      ? [
          {
            uid: "-1",
            name: "useful-tips.jpg",
            status: "done",
            url: decodeHTML(editHelpHeading?.image),
          },
        ]
      : "",
  },
  fields: fields.dineListPageContent.map((field: any) => {
    if (field.name === "category") {
      return {
        ...field,
        options:
          currentAirport === "klia1" || currentAirport === "klia2"
            ? kliaAirportDropdownOptions
            : airportDropdownOptions,
      };
    }
    if (field.name === "zone") {
      return {
        ...field,
        editable: currentAirport === "klia1" || currentAirport === "klia2",
        validation:
          currentAirport === "klia1" || currentAirport === "klia2"
            ? { required: "Zone is required" }
            : undefined,
      };
    }
    if (field.name === "zoneLevel") {
      return {
        ...field,
        note: (currentAirport === "klia1" || currentAirport === "klia2") && "Kindly select the Zone before selecting the Zone Level",
        loadOptions: async (zone: string) => {
          return await FetchSubModule(zone || decodeHTML(editHelpHeadingById?.payload?.zone) || decodeHTML(editHelpHeading?.zone), currentAirport ?? "all");
        },
      };
    }
    return field;
  }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action,
      method,
      module: "Shop & Dine",
      subModule: "dine_dineList_dineListPageContent",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editHelpHeading?.id || editHelpHeadingById?.payload?.id,
        }),
        ...data,
        airport: currentAirport,
        type: "dine",
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Dine Store List`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${passengerHost}/api/shop-dine-services/${editHelpHeading?.id || editHelpHeadingById?.payload?.id}` : `${passengerHost}/api/shop-dine-services`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Shop & Dine"
      />
    </ContentWrapper>
  );
};
